import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Lottie from "lottie-react";
import animationData from "../../assets/lottie/mobile.json";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";

export const StatusModal = ({ show, setShow }) => {
  const navigate = useNavigate();

  return (
    <>
      <Transition className="z-[9999]" appear show={show} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => setShow(false)}
        >
          <div className="fixed sm:px-0 px-4 inset-0 bg-black bg-opacity-50 pointer-events-auto">
            <div className="flex min-h-full items-center justify-center text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="object-contain container transform overflow-y-auto rounded-2xl bg-secondary max-w-lg text-left shadow-xl transition-all">
                  <div className="flex relative justify-center items-center flex-col gap-y-2 p-10">
                    <RxCross2
                      size={20}
                      onClick={() => setShow(false)}
                      className="text-primary absolute top-6 right-6 cursor-pointer"
                    />
                    <div className="sm:text-2xl text-xl font-bold text-center text-primary">
                      Excited to Collaborate!
                    </div>
                    <div className="sm:text-xl text-md text-primary text-center">
                      I'm currently open to working on exciting new projects and
                      opportunities, whether part-time, contract, or full-time.
                      Let's bring innovative ideas to life and create
                      exceptional experiences together! 🚀
                    </div>
                    <Lottie
                      onClick={() => {
                        setShow(false);
                        navigate("/contact");
                      }}
                      className="w-52 cursor-pointer"
                      animationData={animationData}
                      loop={true}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
